"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateFilter = void 0;

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var DateFilter = function DateFilter(_ref) {
  var beforeDatePickerProps = _ref.beforeDatePickerProps,
      afterDatePickerProps = _ref.afterDatePickerProps,
      suffix = _ref.suffix;
  return react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(antd_1.DatePicker, Object.assign({
    placeholder: 'After Date'
  }, afterDatePickerProps)), react_1["default"].createElement("span", null, "\xA0\xA0\xA0\u2014\xA0\xA0\xA0"), react_1["default"].createElement(antd_1.DatePicker, Object.assign({
    placeholder: 'Before Date'
  }, beforeDatePickerProps)), suffix);
};

exports.DateFilter = DateFilter;